<div class="page-content page-fill">
  <div class="d-flex">
    <dx-date-box class="classis-datePicker" [(value)]="startDate" [placeholder]="'Start Date'" ></dx-date-box>
    <dx-date-box class="classis-datePicker" [(value)]="endDate" [placeholder]="'End Date'"> </dx-date-box>
  </div>

  <div style="margin-top: 10px; margin-bottom: 10px">
    <!-- Batch Status: -->
    <dx-select-box [items]="statuses" [(value)]="selectedStatus" valueExpr="id" displayExpr="name" [width]="325"></dx-select-box>
  </div>

  <div class="row">
    @if (classisBatches) {
      <div class="grid-fill col-sm-6" style="max-width: 700px">
        <dx-data-grid
          #classisGrid
          height="700px"
          [dataSource]="classisBatches"
          keyExpr="dxKey"
          [columnAutoWidth]="false"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          (onFocusedRowChanging)="onSelectionChanged($event)"
          >
          <dxo-paging [enabled]="false"></dxo-paging>
          <dxo-selection mode="multiple"></dxo-selection>
          <dxi-column dataField="name" caption="Name" width="350"></dxi-column>
          <dxi-column dataField="classisAccount" caption="Classis Acct" width="150"></dxi-column>
          <dxi-column
            dataField="total"
            dataTye="number"
            [format]="{ type: 'currency', precision: 2 }"
            width="125"
            cssClass="align-right-pad"
          ></dxi-column>
          <dxi-column dataField="paymentForm" width="125" [groupIndex]="0" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>
          <dxo-export [enabled]="true"></dxo-export>
          <dxo-search-panel [visible]="true"></dxo-search-panel>
          <dxo-summary>
            <dxi-group-item
              column="total"
              summaryType="sum"
              [valueFormat]="{ type: 'currency', precision: 2 }"
              displayFormat="Total: {0}"
              [showInGroupFooter]="true"
              [alignByColumn]="true"
              >
            </dxi-group-item>
          </dxo-summary>
          <dxi-sort-by-group-summary-info summaryItem="count"></dxi-sort-by-group-summary-info>
          <div *dxTemplate="let data of 'toolbarButtons'">
            <button class="btn btn-success" (click)="getData()">Refresh</button>
            <button class="btn btn-primary ms-2" (click)="printReport()">Print MonthEnd Report</button>
          </div>
        </dx-data-grid>
      </div>
    }

    @if (classisByBatches) {
      <div class="grid-fill col-sm-6" style="max-width: 1000px">
        <dx-data-grid
          #classisGrid
          height="700px"
          [dataSource]="classisByBatches"
          keyExpr="dxKey"
          [columnAutoWidth]="false"
          (onToolbarPreparing)="onToolbarPreparing($event)"
          (onFocusedRowChanging)="onSelectionChanged($event)"
          >
          <dxo-paging [enabled]="false"></dxo-paging>
          <dxo-selection mode="multiple"></dxo-selection>
          <dxi-column dataField="name" caption="Name" width="350"></dxi-column>
          <dxi-column dataField="batchClassisAccount" caption="Batch Classis Acct" width="150"></dxi-column>
          <dxi-column dataField="batchQBAccount" caption="Batch QB Acct" width="150"></dxi-column>
          <dxi-column dataField="depositedAccount" caption="Account Name" width="150"></dxi-column>
          <dxi-column dataField="classisAccount" caption="Classis Acct" width="150"></dxi-column>
          <dxi-column
            dataField="total"
            dataTye="number"
            [format]="{ type: 'currency', precision: 2 }"
            width="125"
            cssClass="align-right-pad"
          ></dxi-column>
          <dxi-column dataField="paymentForm" width="125" [groupIndex]="0" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>
          <dxo-export [enabled]="true"></dxo-export>
          <dxo-search-panel [visible]="true"></dxo-search-panel>
          <dxo-summary>
            <dxi-group-item
              column="total"
              summaryType="sum"
              [valueFormat]="{ type: 'currency', precision: 2 }"
              displayFormat="Total: {0}"
              [showInGroupFooter]="true"
              [alignByColumn]="true"
              >
            </dxi-group-item>
          </dxo-summary>
          <dxi-sort-by-group-summary-info summaryItem="count"></dxi-sort-by-group-summary-info>
          <div *dxTemplate="let data of 'toolbarButtons'">
            <button class="btn btn-success" (click)="getData()">Refresh</button>
          </div>
        </dx-data-grid>
      </div>
    }
  </div>
</div>
